<div class="teacher-timer-setup" #mainEl>
  <div class="teacher-timer-setup__hint">
    <brt-pulse-circle></brt-pulse-circle>
    <span>Diese Woche noch {{maxMinutes}} Minuten Spielzeit für die Klasse verfügbar</span>
  </div>

  <div class="teacher-timer-setup__input-wrapper">
    <div class="teacher-timer-setup__number" (click)="setFocus(0)" [ngClass]="{'focused': currentFocus === 0}">

      <input type="text" (blur)="removeFocus(0)" (keyup)="onKeyUp($event, 0)" [value]="currentMinutesString" id="teacher-timer-setup-input-0" autocomplete="off">
      <span>{{currentMinutes|leadingZero:2}}</span>
    </div>

    <div class="teacher-timer-setup__separator">:</div>

    <div class="teacher-timer-setup__number" (click)="setFocus(1)" [ngClass]="{'focused': currentFocus === 1}">
      <input type="text" (blur)="removeFocus(1)" (keyup)="onKeyUp($event, 1)" id="teacher-timer-setup-input-1" autocomplete="off">
      <span>{{currentSeconds|leadingZero:2}}</span>
    </div>
  </div>

  <div class="teacher-timer-setup__action-button" (click)="incrementMinutes(5)">
    + 5 Min.
  </div>
</div>
